(() => {
  const GLOBAL_KEY = '__mtBlackFridayFaq';
  const SECTION_SELECTOR = '[data-mt-blackfriday-faq]';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll(document);
    return;
  }

  const findSections = (container = document) => {
    const sections = [];

    if (container?.matches?.(SECTION_SELECTOR)) sections.push(container);
    container?.querySelectorAll?.(SECTION_SELECTOR).forEach((section) => sections.push(section));

    return sections;
  };

  const setItemState = (item, expanded) => {
    const trigger = item.querySelector('[data-faq-trigger]');
    const answer = item.querySelector('[data-faq-answer]');
    if (!trigger || !answer) return;

    item.classList.toggle('is-open', expanded);
    trigger.setAttribute('aria-expanded', String(expanded));
    answer.setAttribute('aria-hidden', String(!expanded));

    if ('inert' in answer) answer.inert = !expanded;
  };

  const initSection = (section) => {
    if (!section || section.dataset.faqInitialized === 'true') return;
    section.dataset.faqInitialized = 'true';

    section.querySelectorAll('.mt-blackfriday-faq__item').forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      setItemState(item, trigger.getAttribute('aria-expanded') === 'true');
      trigger.addEventListener('click', () => {
        setItemState(item, trigger.getAttribute('aria-expanded') !== 'true');
      });
    });
  };

  const initAll = (container = document) => findSections(container).forEach(initSection);

  window[GLOBAL_KEY] = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
